module.exports = __webpack_public_path__ + "static/media/14.1ad41da9.jpg";